export default __webpack_public_path__ + "static/media/dessert.260e7760.png";